import React from 'react';

import Tag from './Tag';
import * as sassVars from '../style/_common.scss';
import * as util from '../util';

const TypeTag = ({ p }) => {
  let kindColorMap = {
    pure: sassVars.greenColor,
    hybrid: sassVars.redColor,
    onsite: sassVars.blueColor,
    unknown: sassVars.yellowColor,
  };

  let kindDescMap = {
    pure: 'Fully cash-based, no relationships with insurance companies',
    hybrid: 'Some patients are DPC, some pay with insurance',
    unknown: "It's not known whether this practice is pure or hybrid DPC.",
    onsite:
      'Operated by a large company for use by employees, typically not open to general public',
  };

  const onsiteOrKind = p.onsite ? 'onsite' : p.kind || 'pure';

  let tagText = [];
  if (p.onsite === true) tagText.push('Onsite');
  if (p.mobile === true) tagText.push('Mobile');
  tagText.push(util.capitalize(p.kind) || 'Pure');
  tagText.push('DPC');

  let color = kindColorMap[onsiteOrKind];
  let desc = kindDescMap[onsiteOrKind];

  return (
    <span title={desc} style={{ cursor: 'text' }}>
      <Tag color={color}>{tagText.join(' ')}</Tag>
    </span>
  );
  // if (p.onsite === true) {
  //   console.log('returning onsite tag');
  //   return (
  //     <span
  //       title="Operated by a large company for use by employees, typically not open to general public"
  //       style={{ cursor: 'text' }}
  //     >
  //       <Tag color={sassVars.blueColor}>Onsite</Tag>
  //     </span>
  //   );
  // }

  // if (p.kind === 'pure')
  //   return (
  //     <span
  //       title="Fully cash-based, no relationships with insurance companies"
  //       style={{ cursor: 'text' }}
  //     >
  //       <Tag color={kindColorMap[p.kind] || sassVars.greenColor}>Pure</Tag>
  //     </span>
  //   );

  // if (p.kind === 'hybrid')
  //   return (
  //     <span
  //       title="Some patients are DPC, some pay with insurance"
  //       style={{ cursor: 'text' }}
  //     >
  //       <Tag color={kindColorMap[p.kind] || sassVars.redColor}>Hybrid</Tag>
  //     </span>
  //   );

  // if (p.kind === 'unknown')
  //   return (
  //     <span
  //       title="It's not known whether this practice is pure or hybrid DPC."
  //       style={{ cursor: 'text' }}
  //     >
  //       <Tag color={kindColorMap[p.kind] || sassVars.yellowColor}>Unknown</Tag>
  //     </span>
  //   );

  // return null;
};

export default TypeTag;
